@if (member !== undefined) {
  {{ [member.firstName, member.infix, member.lastName].join(' ') }}
  @if (isBirthday) {
    <span (click)="celebrate($event)">🎉</span>
  }
}
@if (member === undefined) {
  ...
}